import React, { useEffect, useRef, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { cloneDeep, get, isEmpty, uniqueId } from 'lodash';
import { Container } from 'containers/LawyerLegalProceedingsPage/judgementAdd/styled-components';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { Listings } from 'containers/AppContainer/typings';
import { CivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import { PAGES } from 'routes';
import {
  IJudgementAdd,
  IUploadedDocument,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { DRAWERS } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import ProcedureInformationDrawer from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/ProcedureInformationDrawer';
import { IndexState } from 'containers/LawyerLegalProceedingsPage/judgementAdd/typings';
import CivilPartyDrawer from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/CivilPartyDrawer';
import JudgementAddPronouncingDrawer from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/JudgementAddPronouncingDrawer';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/messages';
import { translate } from 'containers/services/translate';
import {
  formatCourtFileNumber,
  getPendingFeeNotesByStep,
  toBeEdited,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import {
  EMPTY_SUPPORT_DOCUMENT,
  PROCEDURE_STATUSES,
} from 'containers/data-structure';
import { pushTo } from 'containers/services/routes-helper';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { getPartiesIds } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/utils';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { FeeNoteType, VictimType } from 'typings/globalTypes';
import currentUserStorage from 'containers/services/security/current-user-storage';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import {
  getLimitInvoiceIntervenant,
  getLimitInvoiceManager,
} from 'services/utils';
import { PROCEDURE_STEPS } from 'containers/LawyerFeeNote/constants';
import moment from 'moment-timezone';
import { makeSelectFeeNotes } from 'containers/LawyerFeeNote/selectors';
import { useSelector } from 'react-redux';

export interface EditJudgementAddOnRejectionProps {
  intl: IntlShape;
  listings: Listings;
  vehicules: Vehicule[];
  victims: VictimType[];
  judgementAddStore: IJudgementAdd | {};
  judgementAdd: IJudgementAdd | {};
  setJudgementAdd: Function;
  handleIsDrawerOpen: Function;
  isDrawerOpen: any;
  isCivilProceeding?: boolean;
  currentIndex: IndexState;
  lossDate: string;
  claimNumber: string;
  requestUpdateJudgementAdd: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  setDocumentId: Function;
  documentId: any;
  isAssignedLawyer: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  currentJudiciaryProcess: any;
  requestGetDocByDocumentumId: Function;
  feeNotes: FeeNoteType[];
}

export const EditJudgementAddOnRejection: React.FC<EditJudgementAddOnRejectionProps> = (
  props,
): JSX.Element => {
  const [procedureInformations, setProcedureInformations] = useState<
    Idetails | {}
  >({});
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = useState<boolean>(false);
  const currentFeeNoteIndexRef = useRef<number>(0);
  const [currentFeeNoteIndex, setCurrentFeeNoteIndex] = useState<number | null>(
    null,
  );
  useEffect(() => {
    if (currentFeeNoteIndex !== null) {
      currentFeeNoteIndexRef.current = currentFeeNoteIndex;
    }
  }, [currentFeeNoteIndex]);

  const [invoiceDocument, setInvoiceDocument] = useState({});
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [invoiceFeeNotes, setInvoiceFeeNotes] = useState([]);
  const [civilDocumentsVictims, setCivilDocumentsVictims] = useState<
    Set<number>
  >(new Set());
  const [documentCivilKK, setDocumentCivilKK] = useState({
    ...EMPTY_SUPPORT_DOCUMENT,
  });
  const [judgementAddExpertises, setJudgementAddExpertises] = useState<
    JudgementADDDocumentType[] | []
  >([]);
  const feeNotesStore = useSelector(makeSelectFeeNotes());
  const isCourtMonitoringManager =
    userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
    !userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER);

  useEffect(() => {
    props.setJudgementAdd(cloneDeep(props.judgementAddStore));
    setProcedureInformations(
      cloneDeep(get(props.judgementAddStore, 'judgementAdd', {})),
    );
    setJudgementAddExpertises(
      get(props.judgementAddStore, 'judgementAddDocuments', []).map(
        (jadd: any) => ({
          ...jadd,
          expertises: jadd.expertises.filter(
            (exp: any) => !isEmpty(exp.vehicules) || !isEmpty(exp.victims),
          ),
        }),
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.judgementAddStore, props.isCivilProceeding]);
  useEffect(() => {
    const _civilDocuments = get(props.judgementAddStore, 'civilDocuments', []);
    const vicIds = getPartiesIds(
      get(
        _civilDocuments[props.currentIndex[DRAWERS.CIVIL_PARTY]],
        'victims',
        [],
      ),
    );
    setCivilDocumentsVictims(new Set(vicIds));
    setDocumentCivilKK(
      _civilDocuments[props.currentIndex[DRAWERS.CIVIL_PARTY]],
    );
  }, [props.judgementAddStore, props.isCivilProceeding]);

  const customJudgementAddSetter = (
    fieldName: string,
    fieldToSet: Idetails | CivilParty[] | JudgementADDDocumentType[],
  ) => {
    props.setJudgementAdd({
      ...props.judgementAdd,
      [fieldName]: fieldToSet,
    });
  };
  const feeNotes = getPendingFeeNotesByStep(
    feeNotesStore,
    get(props.judgementAdd, 'procedureType', '') ===
      PROCEDURE_TYPES.FIRST_INSTANCE
      ? PROCEDURE_STEPS.JUDGEMENT_ADD
      : PROCEDURE_STEPS.ARRET_ADD,
    get(props.judgementAdd, 'id'),
    get(props.judgementAdd, 'judgementAddDocuments', [])
      .filter((el: any) => el.status === '') //only pronouncing simple
      .map((item: any) => item.id),
    currentIntervenantStorage?.get()?.sagis_code,
  );
  const handleOpenValidate = () => {
    if (
      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
      !isEmpty(feeNotes)
    ) {
      setOpenInvoiceFeeNoteInfoDialog(true);
    } else {
      handleValidate();
    }
  };
  const handleValidate = (invoiceFeeNotes?: any) => {
    props.requestUpdateJudgementAdd(
      {
        judgementAdd: {
          ...props.judgementAdd,
          claimNumber: props.claimNumber,
          rejectionReason: null,
          status: PROCEDURE_STATUSES.PENDING,
          validator: null,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          updatedBy: currentIntervenantStorage.get()
            ? currentIntervenantStorage.get()?.preferred_username
            : currentUserStorage?.get()?.username,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          judgementAdd: {
            ...get(props.judgementAdd, 'judgementAdd', {}),
            courtFile: formatCourtFileNumber(
              get(props.judgementAdd, 'judgementAdd.courtFile', ''),
            ),
          },
        },
        invoiceFeeNotes: invoiceFeeNotes,
        isManager: isCourtMonitoringManager,
        isLawyer: currentIntervenantStorage.get() ? true : false,
      },
      handleSuccessCallback,
    );
  };
  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleValidateInvoice = () => {
    const currentItem = feeNotes[currentFeeNoteIndexRef.current];
    const invoiceFeeNoteId = get(currentItem, 'invoiceFeeNote.id');
    const updatedInvoiceFeeNotes = [
      ...invoiceFeeNotes,
      {
        id: invoiceFeeNoteId,
        invoiceNumber: invoiceNumber,
        invoiceDate: invoiceDate,
        receptionDate: moment().format('YYYY-MM-DD'),
        ...invoiceDocument,
      },
    ];
    setInvoiceFeeNotes(updatedInvoiceFeeNotes as any);

    setInvoiceNumber('' as any);
    setInvoiceDocument({});
    setInvoiceDate(null);
    setOpenInvoiceFeeNoteInfoDialog(false);
    if (
      updatedInvoiceFeeNotes.length ===
      feeNotes.map((el: any) => el.invoiceFeeNote).length
    ) {
      setCurrentFeeNoteIndex(null);
      handleValidate(updatedInvoiceFeeNotes);
    } else {
      currentFeeNoteIndexRef.current = currentFeeNoteIndexRef.current + 1;
      setCurrentFeeNoteIndex(currentFeeNoteIndexRef.current);
      setOpenInvoiceFeeNoteInfoDialog(true);
    }
  };
  const handleSuccessCallback = () => {
    const message =
      get(props.judgementAdd, 'procedureType', '') ===
      PROCEDURE_TYPES.FIRST_INSTANCE
        ? messages.validationJudgementAddMessage
        : messages.validationAppealAddMessage;
    toast.success(translate(message, props));
    if (!featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
      !userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER)
        ? pushTo(PAGES.COURT_MANAGER_HOME)()
        : pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    } else {
      currentIntervenantStorage.get() && pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    }
  };
  return (
    <Container id="add-bloc">
      <ProcedureInformationDrawer
        open={props.isDrawerOpen[DRAWERS.PROCEDURE_INFORMATION]}
        handleToggleDrawer={props.handleIsDrawerOpen(
          DRAWERS.PROCEDURE_INFORMATION,
        )(props.currentIndex[DRAWERS.PROCEDURE_INFORMATION])}
        details={procedureInformations as Idetails}
        setDetails={setProcedureInformations}
        listings={props.listings}
        setJudgementAdd={customJudgementAddSetter}
        vehicules={props.vehicules}
        lossDate={props.lossDate}
        sagisOpposingParties={props.sagisOpposingParties}
        currentJudiciaryProcess={props.currentJudiciaryProcess}
      />
      {!props.isCivilProceeding && (
        <CivilPartyDrawer
          key={uniqueId('civil-doc-drawer')}
          open={props.isDrawerOpen[DRAWERS.CIVIL_PARTY]}
          handleToggleDrawer={props.handleIsDrawerOpen(DRAWERS.CIVIL_PARTY)(
            props.currentIndex[DRAWERS.CIVIL_PARTY],
          )}
          civilDocuments={get(props.judgementAdd, 'civilDocuments', [])}
          index={props.currentIndex[DRAWERS.CIVIL_PARTY]}
          setJudgementAdd={customJudgementAddSetter}
          victims={props.victims}
          civilDocumentsVictims={civilDocumentsVictims}
          setCivilDocumentsVictims={setCivilDocumentsVictims}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocuments={props.resetUploadedDocument}
          setDocumentId={props.setDocumentId}
          document={documentCivilKK}
          setDocument={setDocumentCivilKK}
          documentId={props.documentId}
          sagisVictimInfo={props.sagisVictimInfo}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      <JudgementAddPronouncingDrawer
        open={props.isDrawerOpen[DRAWERS.JUDGEMENT_ADD]}
        handleToggleDrawer={props.handleIsDrawerOpen(DRAWERS.JUDGEMENT_ADD)(
          props.currentIndex[DRAWERS.JUDGEMENT_ADD],
        )}
        victims={props.victims}
        vehicules={props.vehicules}
        setJudgementAdd={customJudgementAddSetter}
        index={props.currentIndex[DRAWERS.JUDGEMENT_ADD]}
        judgementAddExpertises={
          judgementAddExpertises as JudgementADDDocumentType[]
        }
        setJudgementAddExpertises={setJudgementAddExpertises}
        listings={props.listings}
        hearingDate={get(procedureInformations, 'hearingDate')}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        resetUploadedDocument={props.resetUploadedDocument}
        judgementAddDocumentsStore={get(
          props.judgementAdd,
          'judgementAddDocuments',
          [],
        )}
        sagisVictimInfo={props.sagisVictimInfo}
        sagisOpposingParties={props.sagisOpposingParties}
        judgementOnMerits={{} as any}
      />
      {toBeEdited(get(props, 'judgementAddStore.status', '')) &&
        (props.isAssignedLawyer ||
          userPrivileges.userHasPrivilege(
            PRIVILEGES.ISCOURTMONITORINGMANAGER,
          )) && (
          <PrimaryButton
            className="button"
            title={translate(messages.validate, props)}
            data-testId="validate"
            onClick={handleOpenValidate}
            background={BUTTON_COLORS.PRIMARY_BLUE}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
          />
        )}
      {featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
        !isEmpty(feeNotes) &&
        feeNotes.map((item: FeeNoteType) => (
          <InvoiceInfoDialog
            open={openInvoiceFeeNoteInfoDialog}
            onClose={handleCloseInvoiceFeeNote}
            handleValidate={handleValidateInvoice}
            invoiceNumber={invoiceNumber}
            invoiceDate={invoiceDate}
            setInvoiceNumber={setInvoiceNumber}
            setInvoiceDate={setInvoiceDate}
            resetUploadedDocument={props.resetUploadedDocument}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            invoiceDocument={invoiceDocument}
            setInvoiceDocument={setInvoiceDocument}
            displayUpdateTitle={true}
            isManager={false}
            limitInvoiceDate={
              isCourtMonitoringManager
                ? getLimitInvoiceManager(get(props.listings, 'appConfig', []))
                : getLimitInvoiceIntervenant(
                    get(props.listings, 'appConfig', []),
                  )
            }
          />
        ))}
    </Container>
  );
};

export default injectIntl(EditJudgementAddOnRejection);
